import { Command, CommandResult } from '../procedure.interface';
import { Device } from '@/device';
import { FileDownloader } from '@/helpers/file-downloader';
import { InstallProperties } from '@/interfaces/properties.interface';
import { Logger } from '@/logger';
import { AdbSync } from '@yume-chan/adb';

export class WriteRemoteFileCommand implements Command {
  public fileUrl: string;
  public devicePath: string;
  public stopOnError: boolean;
  public type: string;

  constructor(devicePath: string, fileUrl: string) {
    this.stopOnError = true;
    this.type = 'writeFile';
    this.fileUrl = fileUrl;
    this.devicePath = devicePath;
  }

  public toLog(): string {
    const fileName = this.devicePath.split('/').pop();
    return `Writing file ${fileName}`;
  }

  public async execute(device: Device, logger: Logger, _?: InstallProperties): Promise<CommandResult> {
    if (!device.adb) {
      return Promise.resolve({
        success: false,
        message: 'Not connected',
      });
    }

    try {
      // Fetch file
      const fileDownloader = new FileDownloader(this.fileUrl);
      const { stream } = await fileDownloader.getStream(logger.logProgress('Downloading file'));

      // Write file
      const sync: AdbSync = await device.adb.sync();
      await sync.write({
        filename: this.devicePath,
        file: stream,
      });
      await sync.dispose();
    } catch (error: unknown) {
      return Promise.resolve({
        success: false,
        message: (error as Error).message,
      });
    }

    return Promise.resolve({
      success: true,
      message: 'OK',
    });
  }
}
